import axios from './HTTP'

export default {
  getCallIn () {
    return axios
      .get('/api/call_in_settings.json')
  },

  updateCallIn (params) {
    return axios
      .patch('/api/call_in_settings.json', params)
  },

  create (params, callback, errorCallback) {
    axios
      .post(`/api/holidays.json`, {
        holiday: params
      })
      .then(response => { callback(response.data) })
      .catch(error => { errorCallback(error) })
  },

  delete (id, callback, errorCallback) {
    axios
      .delete(`/api/holidays/${ id }.json`)
      .then(response => { callback(response.data) })
      .catch(error => { errorCallback(error) })
  },

  debugSunset () {
    return axios.get('/api/debug/sunset.json')
  }

}
